import { Markdown, Modal, ModalBody, ModalHeader } from '@coolblue-development/freddy';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';

type Props = {
  description: string;
  open: boolean;
  onClose: () => void;
  title: string;
};

export default function AttributeDetailsModal({ description, open, onClose, title }: Props) {
  const modalTranslations = useFreddyTranslations('modal');

  return (
    <Modal
      body={
        <ModalBody>
          <Markdown>{description}</Markdown>
        </ModalBody>
      }
      open={open}
      onClose={onClose}
      size='medium'
      header={<ModalHeader title={title} truncateLines={2} />}
      translations={modalTranslations}
    />
  );
}
